module.exports = __webpack_public_path__ + "img/you002.ec50fd62.png";